<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    :column-key="filterName"
    :filters="salesModeFilter"
    :filtered-value="filteredValue"
    :filter-multiple="true"
    align="center"
    >
    <template slot-scope="scope">
      <brand-field
        v-if="isShowBrand"
        :base="base"
        :row="scope.row"
      >
      </brand-field>
      <div class="product-field-layout">
        <div class="left">
          <el-popover
            v-if="isShowOrdersSource && isNeedOrdersSource(scope.row)"
            placement="bottom"
            trigger="hover"
            :width="320"
            >
            <div class="pop-content">
              <pop-row
                :label="$t('api.optFields.ordersSource.label')"
                :content="getMapLabel(getMap('ordersSource'), scope.row.source)"
                :filter="() => {updateRoute([{'field': 'source', 'value': scope.row.source}])}"
              >
              </pop-row>
              <pop-row
                :label="$t('api.orders.fields.eatigo_booking_id.short')"
                :content="scope.row.eatigo_booking_id"
                :hasFilter="false"
              >
              </pop-row>
              <pop-row
                v-if="scope.row.rwg_type != null"
                :label="$t('api.orders.fields.rwg_type.label')"
                :content="getMapLabel(getMap('branchRwgType'), scope.row.rwg_type)"
                :filter="() => {updateRoute([{'field': 'rwg_type', 'value': scope.row.rwg_type}])}"
              >
              </pop-row>
              <pop-row
                v-if="scope.row.booking_type !== 0"
                :label="$t('api.orders.fields.booking_type.label')"
                :content="getMapLabel(getMap('bookingType'), scope.row.booking_type)"
                :filter="() => {updateRoute([{'field': 'booking_type', 'value': scope.row.booking_type}])}"
              >
              </pop-row>
            </div>
            <el-button
              slot="reference"
              circle
              size="mini"
              class="brand-icon-btn no-click"
            >
              <el-image
                v-if="isShowBrandFromSource(scope.row.source)"
                class="brand-icon"
                :src="getBrandIcon(convertOrdersSourceToBrandID(scope.row.source))"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <i v-else :class="getIconClass(scope.row.source)"></i>
            </el-button>
          </el-popover>
        </div>
        <div class="right">

      <el-badge
        :hidden="true"
        ><!-- only for align text with branch -->
        <item-link
          v-if="typeof scope.row.region_id !== 'undefined'"
          base="region"
          basePath="/region/region"
          idField="region_id"
          nameField="region_name"
          :rowData="scope.row"
          :isAllowList="isRegionList"
          :isAllowSearch="isRegionSearch"
          :displayType="isRegionLink ? 'link' : 'text'"
          type="info"
          class="list-sub"
          >
          <template slot="prepend">
            <el-image
              v-if="isShowRegionBrand && typeof scope.row.brand_id !== 'undefined'"
              class="brand-icon"
              :src="getBrandIcon(scope.row.brand_id)"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </item-link>
      </el-badge>
      <el-badge
        :hidden="(typeof scope.row.branch_platform === 'undefined') || (scope.row.branch_platform === 0)"
        :value="getMapLabel(getMap('platform'), scope.row.branch_platform)"
        class="pos-right"
        type="success"
        >
        <item-link
          base="branch"
          basePath="/merchant/branch"
          :baseIDField="baseBIDField"
          idField="bid"
          :unhideIDField="unhideBIDField"
          :nameField="branchNameField"
          :rowData="scope.row"
          :isAllowList="isBranchList"
          :displayType="isBranchLink ? 'link' : 'text'"
          type="primary"
          class="list-main"
          >
        </item-link>
      </el-badge>
      <div
        v-if="isShowProduct && scope.row[productIDField]"
        class="data-badges"
        >
        <el-badge
          :hidden="(typeof scope.row.quantity === 'undefined') || (scope.row.quantity <= 1)"
          :value="'×'+scope.row.quantity"
          class="pos-right"
          type="primary"
          >
          <item-link
            base="product"
            basePath="/merchant/product"
            :idField="productIDField"
            :unhideIDField="unhideProductIDField"
            :nameField="productNameField"
            :rowData="scope.row"
            :isAllowList="isProductList"
            :displayType="isProductLink ? 'link' : 'text'"
            type="primary"
            class="list-main"
            >
          </item-link>
        </el-badge>
      </div>
      <div v-if="isShowUpgrade">
        <item-link
          base="upgrade"
          basePath="/merchant/upgrade"
          :idField="upgradeIDField"
          :nameField="upgradeNameField"
          :rowData="scope.row"
          :isAllowList="isUpgradeList"
          :displayType="isUpgradeLink ? 'link' : 'text'"
          type="primary"
          >
        </item-link>
      </div>
      <div v-if="isShowResource">
        <item-link
          base="resource_group"
          basePath="/merchant/resource/resource_group"
          baseIDField="rg_id"
          :idField="rscIDField"
          unhideIDField="unhide_rgid"
          :nameField="rscNameField"
          :rowData="scope.row"
          :isAllowList="isResourceList"
          :displayType="isResourceLink ? 'link' : 'text'"
          type="primary"
          >
        </item-link>
      </div>
    </div>
      </div>
    </template>
  </el-table-column>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { updateFilter } from '@/utils/filter'
import { updateRoute } from '@/utils/route'
import { getMap, getMapLabel, getTransText, getLabelText } from '@/utils/i18n'
import { BrandIcon, OrdersSource, OrdersSourceToBrandID } from '@/enums'

export default {
  name: 'product-field',
  props: {
    base: {
      type: String,
      default: ''
    },
    isRegionLink: {
      type: Boolean,
      default: true
    },
    isRegionList: {
      type: Boolean,
      default: true
    },
    isRegionSearch: {
      type: Boolean,
      default: true
    },
    isBranchLink: {
      type: Boolean,
      default: true
    },
    isBranchList: {
      type: Boolean,
      default: true
    },
    isProductLink: {
      type: Boolean,
      default: true
    },
    isProductList: {
      type: Boolean,
      default: true
    },
    isUpgradeLink: {
      type: Boolean,
      default: true
    },
    isUpgradeList: {
      type: Boolean,
      default: true
    },
    isResourceLink: {
      type: Boolean,
      default: true
    },
    isResourceList: {
      type: Boolean,
      default: true
    },
    branchNameField: {
      type: String,
      default: 'branch_name'
    },
    baseBIDField: {
      type: String,
      default: 'bid'
    },
    unhideBIDField: {
      type: String,
      default: 'unhide_bid'
    },
    productIDField: {
      type: String,
      default: 'product_id'
    },
    unhideProductIDField: {
      type: String,
      default: 'unhide_pid'
    },
    productNameField: {
      type: String,
      default: 'product_name'
    },
    upgradeIDField: {
      type: String,
      default: 'upgrade_id'
    },
    upgradeNameField: {
      type: String,
      default: 'upgrade_name'
    },
    rscIDField: {
      type: String,
      default: 'rg_id'
    },
    rscNameField: {
      type: String,
      default: 'name'
    },
    isShowBrand: {
      type: Boolean,
      default: false
    },
    isShowRegionBrand: {
      type: Boolean,
      default: true
    },
    isShowOrdersSource: {
      type: Boolean,
      default: true
    },
    isShowBranch: {
      type: Boolean,
      default: true
    },
    isShowProduct: {
      type: Boolean,
      default: true
    },
    isShowUpgrade: {
      type: Boolean,
      default: false
    },
    isShowResource: {
      type: Boolean,
      default: false
    },
    hasFilter: {
      type: Boolean,
      default: false
    },
    filterName: {
      type: String,
      default: 'sales_mode'
    },
    labelText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      filteredValue: []
    }
  },
  mounted () {
    if (this.hasFilter) {
      this.$nextTick(() => {
        this.updateFilter(this.filterName)
      })
    }
  },
  computed: {
    salesModeFilter () {
      if (!this.hasFilter) {
        return null
      }
      let m = this.getMap('salesMode')
      let filters = []
      for (let i = 0; i < m.length; i++) {
        filters.push({
          value: m[i]['value'],
          text: m[i]['label']
        })
      }
      return filters
    },
    label () {
      return this.labelText || this.getTransText('product', 'label', 'common')
    }
  },
  methods: {
    doCopy,
    updateRoute,
    getMap,
    getMapLabel,
    getLabelText,
    getTransText,
    updateFilter,
    getBrandIcon (id) {
      return BrandIcon[id]
    },
    isNeedOrdersSource (row) {
      if (row.source === null || row.source === undefined) {
        return false
      }
      if (row.source === OrdersSource.FunNow) {
        if ((row.rwg_type !== null && row.rwg_type !== undefined) ||
          row.booking_type !== 0) {
          return true
        }
        return false
      }
      return true
    },
    isShowBrandFromSource (source) {
      return !!OrdersSourceToBrandID[source]
    },
    convertOrdersSourceToBrandID (source) {
      return OrdersSourceToBrandID[source]
    },
    getSalesMode (m) {
      let name = ''
      switch (m) {
        case 1:
          name = 'Play'
          break
        case 2:
          name = 'Pro'
          break
      }
      return {
        sales_mode: m,
        sales_mode_name: name
      }
    },
    getIconClass (t) {
      switch (t) {
        case 1:
          return 'el-icon-s-ticket'
        case 2:
          return 'el-icon-map-location'
        case 3:
          return 'el-icon-reading'
        case 4:
          return 'el-icon-s-claim'
        default:
          return 'el-icon-tickets'
      }
    }
  },
  watch: {
    '$route.query' () {
      if (this.hasFilter) {
        this.updateFilter(this.filterName)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-content {
  margin-top: 6px;
}
.product-field-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  > .left {
    flex-shrink: 0;
    .brand-icon-btn:has(.brand-icon) {
      padding: 2px;
      .brand-icon {
        width: 22px;
        height: 22px;
        padding-top: 3px;
      }
    }
  }
}
</style>
